(function () {
  'use strict';

  var API_URL   = 'https://brilleschmuck.myshopify.com/api/2024-10/graphql.json';
  var TOKEN     = 'f04ab399d796cd0857483422adecaffd';
  var CACHE_KEY = 'ws_marken_all_v3';
  var CACHE_TTL = 300000; // 5 min

  var ALPHA = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('');

  function esc(s) {
    return String(s)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function groupLetter(name) {
    var c = name.charAt(0).toUpperCase();
    return (c >= 'A' && c <= 'Z') ? c : '#';
  }

  // ── Cache ──────────────────────────────────────────────────────────────────

  function getCache() {
    try {
      var raw = sessionStorage.getItem(CACHE_KEY);
      if (!raw) return null;
      var obj = JSON.parse(raw);
      if (Date.now() - obj.ts > CACHE_TTL) return null;
      return obj.brands;
    } catch (e) { return null; }
  }

  function setCache(brands) {
    try {
      sessionStorage.setItem(CACHE_KEY, JSON.stringify({ ts: Date.now(), brands: brands }));
    } catch (e) {}
  }

  // ── Fetch ──────────────────────────────────────────────────────────────────

  function fetchPage(cursor) {
    var afterArg = cursor ? ', after: "' + cursor + '"' : '';
    var query =
      '{ metaobjects(type: "marken", first: 250' + afterArg + ') {' +
        ' nodes { handle fields { key value } }' +
        ' pageInfo { hasNextPage endCursor }' +
      ' } }';
    return fetch(API_URL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': TOKEN,
      },
      body: JSON.stringify({ query: query }),
    }).then(function (res) { return res.json(); });
  }

  function loadAllBrands() {
    var cached = getCache();
    if (cached) return Promise.resolve(cached);

    var allNodes = [];

    function next(cursor) {
      return fetchPage(cursor).then(function (json) {
        var mo = json.data && json.data.metaobjects;
        if (!mo) return;
        allNodes = allNodes.concat(mo.nodes || []);
        if (mo.pageInfo && mo.pageInfo.hasNextPage) {
          return next(mo.pageInfo.endCursor);
        }
      });
    }

    return next(null).then(function () {
      var brands = allNodes
        .map(function (n) {
          var f = {};
          n.fields.forEach(function (field) { f[field.key] = field.value; });
          return { handle: n.handle, name: f.name || '', menu: f.im_menue === 'true' };
        })
        .filter(function (b) { return b.name; })
        .sort(function (a, b) {
          return a.name.localeCompare(b.name, 'de', { sensitivity: 'base' });
        });

      setCache(brands);
      return brands;
    });
  }

  // ── Menu rendering ─────────────────────────────────────────────────────────

  function renderMenu(brands) {
    var menuBrands = brands.filter(function (b) { return b.menu; });

    var grid = document.querySelector('[data-marken-desktop-grid]');
    if (grid) {
      grid.innerHTML = menuBrands.map(function (b) {
        return '<a href="/collections/' + esc(b.handle) + '" class="ws-marken-panel__link">' + esc(b.name) + '</a>';
      }).join('');
    }

    var mobileList = document.querySelector('[data-marken-mobile-list]');
    if (mobileList) {
      mobileList.querySelectorAll('[data-brand-item]').forEach(function (el) { el.remove(); });
      var frag = document.createDocumentFragment();
      menuBrands.forEach(function (b) {
        var li = document.createElement('li');
        li.setAttribute('data-brand-item', '');
        li.innerHTML = '<a href="/collections/' + esc(b.handle) + '" class="ws-header__mobile-sublink">' + esc(b.name) + '</a>';
        frag.appendChild(li);
      });
      mobileList.appendChild(frag);
    }
  }

  // ── Overview rendering ─────────────────────────────────────────────────────

  function renderOverview(brands) {
    var overview = document.querySelector('[data-marken-overview]');
    if (!overview) return;

    // Anzahl
    var countEl = overview.querySelector('[data-marken-count]');
    if (countEl) countEl.textContent = brands.length + ' Marken in unserem Sortiment';

    // Nach Buchstabe gruppieren
    var groups = {};
    brands.forEach(function (b) {
      var letter = groupLetter(b.name);
      if (!groups[letter]) groups[letter] = [];
      groups[letter].push(b);
    });

    var activeLetters = Object.keys(groups);

    // Buchstaben-Nav — A–Z, plus '#' vorne falls nötig
    var navLetters = activeLetters.indexOf('#') !== -1
      ? ['#'].concat(ALPHA)
      : ALPHA.slice();

    var navEl = overview.querySelector('[data-marken-letter-nav]');
    if (navEl) {
      navEl.innerHTML = navLetters.map(function (letter) {
        if (activeLetters.indexOf(letter) !== -1) {
          return '<a href="#letter-' + esc(letter) + '" class="ws-marken-ov__letter-link">' + esc(letter) + '</a>';
        }
        return '<span class="ws-marken-ov__letter-link ws-marken-ov__letter-link--empty" aria-hidden="true">' + esc(letter) + '</span>';
      }).join('');
    }

    // Gruppen
    var groupsEl = overview.querySelector('[data-marken-groups]');
    if (groupsEl) {
      groupsEl.innerHTML = navLetters
        .filter(function (letter) { return groups[letter]; })
        .map(function (letter) {
          var links = groups[letter].map(function (b) {
            return '<a href="/collections/' + esc(b.handle) + '" class="ws-marken-ov__brand-link">' + esc(b.name) + '</a>';
          }).join('');
          return '<div class="ws-marken-ov__group" id="letter-' + esc(letter) + '">'
            + '<h2 class="ws-marken-ov__group-letter">' + esc(letter) + '</h2>'
            + '<div class="ws-marken-ov__group-grid">' + links + '</div>'
            + '</div>';
        }).join('');
    }
  }

  // ── Init ───────────────────────────────────────────────────────────────────

  function init() {
    var hasMenu     = document.querySelector('[data-marken-desktop-grid], [data-marken-mobile-list]');
    var hasOverview = document.querySelector('[data-marken-overview]');
    if (!hasMenu && !hasOverview) return;

    loadAllBrands()
      .then(function (brands) {
        if (hasMenu)     renderMenu(brands);
        if (hasOverview) renderOverview(brands);
      })
      .catch(function (err) { console.warn('[ws-marken-menu]', err); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
}());
